import LogoGo from '../imgs/tech-stack/golang.svg'
import LogoPhp from '../imgs/tech-stack/php.svg'
import LogoReact from '../imgs/tech-stack/react.svg'
import LogoPython from '../imgs/tech-stack/python.svg'
import TechItem from '../components/TechItem/TechItem'

// eslint-disable-next-line import/no-anonymous-default-export
export default [
    // {
    // 	icon: <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M14.738 19.9964C14.8186 19.9988 14.8994 20 14.9806 20C19.3989 20 22.9806 16.4183 22.9806 12C22.9806 7.58172 19.3989 4 14.9806 4C12.4542 4 10.2013 5.17108 8.73522 7H7.51941C3.92956 7 1.01941 9.91015 1.01941 13.5C1.01941 17.0899 3.92956 20 7.51941 20H14.5194C14.5926 20 14.6654 19.9988 14.738 19.9964ZM16.6913 17.721C19.0415 16.9522 20.9806 14.6815 20.9806 12C20.9806 8.68629 18.2943 6 14.9806 6C11.6669 6 8.98059 8.68629 8.98059 12H6.98059C6.98059 10.9391 7.1871 9.92643 7.56211 9H7.51941C5.03413 9 3.01941 11.0147 3.01941 13.5C3.01941 15.9853 5.03413 18 7.51941 18H14.5194C15.0691 18 15.9041 17.9014 16.6913 17.721Z" /></svg>,
    // 	slug: 'cloud-services',
    // 	title: 'Cloud Services',
    // 	text: 'We offer intuitive and cutting-edge IT solutions to enhance your business. Our business services help streamline your operations and achieve greater efficiency.',
    // 	content: <>
    // 		<h2>Gersem Service</h2>
    // 		<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
    // 		<div className="grid g-2 mb-2">
    // 			<img src={require('../imgs/projects/project1.webp')} alt="Gersem Service" />
    // 			<div>
    // 				<h3>Feature</h3>
    // 				<p>Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.</p>
    // 				<ul className="list">
    // 					<li>Lorem solor amet</li>
    // 					<li>Lorem solor amet</li>
    // 					<li>Lorem solor amet</li>
    // 					<li>Lorem solor amet</li>
    // 				</ul>
    // 			</div>
    // 		</div>
    // 		<p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
    // 	</>
    // },
    // {
    // 	icon: <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M11 9V13.1707C9.83481 13.5825 9 14.6938 9 16C9 17.6569 10.3431 19 12 19C13.6569 19 15 17.6569 15 16C15 14.6938 14.1652 13.5825 13 13.1707V9H11ZM11 16C11 15.4477 11.4477 15 12 15C12.5523 15 13 15.4477 13 16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16Z" /> <path d="M12 5C15.866 5 19 8.13401 19 12V13H17V12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12V13H5V12C5 8.13401 8.13401 5 12 5Z" /><path fillRule="evenodd" clipRule="evenodd" d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" /></svg>,
    // 	slug: 'computing',
    // 	title: 'Computing',
    // 	text: 'We offer intuitive and cutting-edge IT solutions to enhance your business. Our business services help streamline your operations and achieve greater efficiency.',
    // 	content: <>
    // 		<h2>Gersem Service</h2>
    // 		<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
    // 		<div className="grid g-2 mb-2">
    // 			<div>
    // 				<h3>Feature</h3>
    // 				<ul className="list">
    // 					<li>Lorem solor amet</li>
    // 					<li>Lorem solor amet</li>
    // 					<li>Lorem solor amet</li>
    // 					<li>Lorem solor amet</li>
    // 					<li>Lorem solor amet</li>
    // 					<li>Lorem solor amet</li>
    // 				</ul>
    // 			</div>
    // 			<img src={require('../imgs/projects/project3.webp')} alt="Gersem Service" />
    // 		</div>
    // 		<p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
    // 	</>
    // },
    // {
    // 	icon: <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M14.1254 13H10.1254V15H14.1254V13Z" /><path fillRule="evenodd" clipRule="evenodd" d="M8.12537 13C9.22994 13 10.1254 12.1046 10.1254 11C10.1254 9.89543 9.22994 9 8.12537 9C7.0208 9 6.12537 9.89543 6.12537 11C6.12537 12.1046 7.0208 13 8.12537 13ZM8.12537 11.5C8.40151 11.5 8.62537 11.2761 8.62537 11C8.62537 10.7239 8.40151 10.5 8.12537 10.5C7.84922 10.5 7.62537 10.7239 7.62537 11C7.62537 11.2761 7.84922 11.5 8.12537 11.5Z" /><path fillRule="evenodd" clipRule="evenodd" d="M18.1254 11C18.1254 12.1046 17.2299 13 16.1254 13C15.0208 13 14.1254 12.1046 14.1254 11C14.1254 9.89543 15.0208 9 16.1254 9C17.2299 9 18.1254 9.89543 18.1254 11ZM16.6254 11C16.6254 11.2761 16.4015 11.5 16.1254 11.5C15.8492 11.5 15.6254 11.2761 15.6254 11C15.6254 10.7239 15.8492 10.5 16.1254 10.5C16.4015 10.5 16.6254 10.7239 16.6254 11Z" /><path fillRule="evenodd" clipRule="evenodd" d="M2.74884 14.6663C3.73056 16.6421 5.76939 18 8.12537 18H16.1254C18.5654 18 20.6652 16.5435 21.6029 14.4525C22.3722 13.9093 22.8746 13.0133 22.8746 12C22.8746 10.9867 22.3722 10.0907 21.6029 9.54753C20.6652 7.45651 18.5654 6 16.1254 6H8.12537C5.76939 6 3.73056 7.3579 2.74884 9.33375C1.78448 9.83263 1.12537 10.8393 1.12537 12C1.12537 13.1607 1.78448 14.1674 2.74884 14.6663ZM8.12537 8H16.1254C17.5088 8 18.7282 8.70234 19.4465 9.76991C19.7227 10.4593 19.8746 11.2119 19.8746 12C19.8746 12.7881 19.7227 13.5407 19.4465 14.2301C18.7282 15.2977 17.5088 16 16.1254 16H8.12537C5.91623 16 4.12537 14.2091 4.12537 12C4.12537 9.79086 5.91623 8 8.12537 8Z" /></svg>,
    // 	slug: 'machine-learning',
    // 	title: 'Machine Learning',
    // 	text: 'Seamless integration of artificial intelligence into corporate processes, driving innovation, optimizing workflows, and enabling more informed decision-making to propel your business forward.',
    // 	content: <>
    // 		<h1>AI Integration for Corporate Processes</h1>
    // 		<p>In today’s rapidly evolving digital landscape, businesses need to stay ahead by adopting cutting-edge
    // 			technologies that drive efficiency, enhance operations, and create sustainable growth. Our AI
    // 			integration services are designed to seamlessly incorporate artificial intelligence into your
    // 			corporate processes, unlocking new opportunities and transforming the way you work.</p>
    //
    // 		<div className="grid g-2 mb-2">
    //
    // 			<h2>What We Offer</h2>
    //
    // 			<p>Tailored AI systems designed to meet your business needs, from predictive analytics to process
    // 				automation. Streamline workflows, enhance data-driven insights, and deliver exceptional customer
    // 				experiences with our comprehensive solutions.</p>
    // 			<img src={require('../imgs/projects/project1.webp')} alt=""/>
    // 		</div>
    //
    // 		<p>Unlock the potential of artificial intelligence to transform your business operations.</p>
    //
    //
    // 		<ul>
    // 			<li><strong>Custom AI Solutions:</strong> Build solutions aligned with your goals and industry
    // 				standards.
    // 			</li>
    // 			<li><strong>Workflow Optimization:</strong> Automate repetitive tasks and boost productivity.</li>
    // 			<li><strong>Data-Driven Insights:</strong> Analyze data for actionable intelligence and better
    // 				decisions.
    // 			</li>
    // 			<li><strong>Enhanced Customer Experience:</strong> Implement AI-driven chatbots and personalization
    // 				tools.
    // 			</li>
    // 			<li><strong>Scalability and Flexibility:</strong> Solutions that grow with your business.</li>
    // 		</ul>
    //
    // 		<h2>Why Choose Us?</h2>
    // 		<p>We bring extensive experience, end-to-end support, and a commitment to ethical AI practices. Partner with
    // 			us for solutions that are transparent, efficient, and designed to drive your business forward.</p>
    //
    // 		<h2>The Impact of AI Integration</h2>
    // 		<p>By integrating AI into your corporate processes, you can expect:</p>
    // 		<ul>
    // 			<li>Increased efficiency through automation.</li>
    // 			<li>Cost savings from optimized resource allocation.</li>
    // 			<li>Enhanced decision-making with real-time insights.</li>
    // 			<li>Improved customer satisfaction through personalization.</li>
    // 		</ul>
    //
    // 	</>
    // },
    {
        icon: (
            <svg
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M14.1254 13H10.1254V15H14.1254V13Z" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.12537 13C9.22994 13 10.1254 12.1046 10.1254 11C10.1254 9.89543 9.22994 9 8.12537 9C7.0208 9 6.12537 9.89543 6.12537 11C6.12537 12.1046 7.0208 13 8.12537 13ZM8.12537 11.5C8.40151 11.5 8.62537 11.2761 8.62537 11C8.62537 10.7239 8.40151 10.5 8.12537 10.5C7.84922 10.5 7.62537 10.7239 7.62537 11C7.62537 11.2761 7.84922 11.5 8.12537 11.5Z"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.1254 11C18.1254 12.1046 17.2299 13 16.1254 13C15.0208 13 14.1254 12.1046 14.1254 11C14.1254 9.89543 15.0208 9 16.1254 9C17.2299 9 18.1254 9.89543 18.1254 11ZM16.6254 11C16.6254 11.2761 16.4015 11.5 16.1254 11.5C15.8492 11.5 15.6254 11.2761 15.6254 11C15.6254 10.7239 15.8492 10.5 16.1254 10.5C16.4015 10.5 16.6254 10.7239 16.6254 11Z"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.74884 14.6663C3.73056 16.6421 5.76939 18 8.12537 18H16.1254C18.5654 18 20.6652 16.5435 21.6029 14.4525C22.3722 13.9093 22.8746 13.0133 22.8746 12C22.8746 10.9867 22.3722 10.0907 21.6029 9.54753C20.6652 7.45651 18.5654 6 16.1254 6H8.12537C5.76939 6 3.73056 7.3579 2.74884 9.33375C1.78448 9.83263 1.12537 10.8393 1.12537 12C1.12537 13.1607 1.78448 14.1674 2.74884 14.6663ZM8.12537 8H16.1254C17.5088 8 18.7282 8.70234 19.4465 9.76991C19.7227 10.4593 19.8746 11.2119 19.8746 12C19.8746 12.7881 19.7227 13.5407 19.4465 14.2301C18.7282 15.2977 17.5088 16 16.1254 16H8.12537C5.91623 16 4.12537 14.2091 4.12537 12C4.12537 9.79086 5.91623 8 8.12537 8Z"
                />
            </svg>
        ),
        slug: 'machine-learning',
        title: 'Machine Learning',
        text: 'Seamless integration of artificial intelligence into corporate processes, driving innovation, optimizing workflows, and enabling more informed decision-making to propel your business forward.',
        content: (
            <>
                <h2>AI Integration for Corporate Processes</h2>
                <p>
                    Unlock the potential of artificial intelligence to transform
                    your business operations. Our AI integration services are
                    designed to seamlessly incorporate artificial intelligence
                    into your corporate processes, unlocking new opportunities
                    and transforming the way you work.
                </p>
                <div className="grid g-2 mb-2">
                    <p>
                        Tailored AI systems designed to meet your business
                        needs, from predictive analytics to process automation.
                        Streamline workflows, enhance data-driven insights, and
                        deliver exceptional customer experiences with our
                        comprehensive solutions.
                    </p>
                    <img
                        src={require('../imgs/projects/project1.webp')}
                        alt="Gersem Service"
                    />
                </div>
                <ul className="list mb-2">
                    <li>
                        <strong>Custom AI Solutions:</strong> Build solutions
                        aligned with your goals and industry standards.
                    </li>
                    <li>
                        <strong>Workflow Optimization:</strong> Automate
                        repetitive tasks and boost productivity.
                    </li>
                    <li>
                        <strong>Data-Driven Insights:</strong> Analyze data for
                        actionable intelligence and better decisions.
                    </li>
                    <li>
                        <strong>Enhanced Customer Experience:</strong> Implement
                        AI-driven chatbots and personalization tools.
                    </li>
                    <li>
                        <strong>Scalability and Flexibility:</strong> Solutions
                        that grow with your business.
                    </li>
                </ul>

                <h3>Why Choose Us?</h3>
                <p>
                    We bring extensive experience, end-to-end support, and a
                    commitment to ethical AI practices. Partner with us for
                    solutions that are transparent, efficient, and designed to
                    drive your business forward.
                </p>

                <h3>The Impact of AI Integration</h3>
                <p>
                    By integrating AI into your corporate processes, you can
                    expect:
                </p>
                <ul className="list mb-2">
                    <li>Increased efficiency through automation.</li>
                    <li>Cost savings from optimized resource allocation.</li>
                    <li>Enhanced decision-making with real-time insights.</li>
                    <li>
                        Improved customer satisfaction through personalization.
                    </li>
                </ul>
            </>
        )
    },
    {
        icon: (
            <svg
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 11C10.2091 11 12 9.20914 12 7C12 4.79086 10.2091 3 8 3C5.79086 3 4 4.79086 4 7C4 9.20914 5.79086 11 8 11ZM8 9C9.10457 9 10 8.10457 10 7C10 5.89543 9.10457 5 8 5C6.89543 5 6 5.89543 6 7C6 8.10457 6.89543 9 8 9Z"
                />
                <path d="M11 14C11.5523 14 12 14.4477 12 15V21H14V15C14 13.3431 12.6569 12 11 12H5C3.34315 12 2 13.3431 2 15V21H4V15C4 14.4477 4.44772 14 5 14H11Z" />
                <path d="M22 11H16V13H22V11Z" />
                <path d="M16 15H22V17H16V15Z" />
                <path d="M22 7H16V9H22V7Z" />
            </svg>
        ),
        slug: 'outsourcing',
        title: 'Outsourcing',
        text: 'Our web studio offers professional development services, combining expertise, quality, transparency, reliability, innovation, scalability, flexibility, efficiency, and affordability in one package.',
        content: (
            <>
                <h2>Why Choose Us?</h2>

                <h4>Expert Team</h4>
                <p>
                    Our team consists of skilled professionals with deep
                    knowledge of modern technologies:
                </p>

                <ul className="mb-2 tech-stack">
                    <li>
                        <TechItem src={ LogoGo } title="Golang" description="High performance and scalability for complex backend systems" />
                    </li>
                    <li>
                        <TechItem src={ LogoPhp } title="PHP" description="A classic solution for web applications and CMS platforms" />
                    </li>
                    <li>
                        <TechItem src={ LogoReact } title="React" description="Dynamic, responsive user interfaces for web and mobile applications" />
                    </li>
                    <li>
                        <TechItem src={ LogoPython } title="Python" description="Powerful tools for data processing, AI, and web development" />
                    </li>
                </ul>

                <h4>Custom Solutions</h4>
                <p>
                    We tailor each project to meet your unique business needs,
                    ensuring optimal performance and long-term value.
                </p>
                <img
                    src={require('../imgs/projects/project4.webp')}
                    alt="Gersem"
                />
                <h4>Our Services</h4>
                <ul className="list mb-2">
                    <li>
                        Backend Development: Build fast, reliable, and scalable
                        server-side applications with Golang and Python.
                    </li>
                    <li>
                        Frontend Development: Create interactive, user-friendly
                        interfaces with React.
                    </li>
                    <li>
                        Full-Stack Solutions: End-to-end development using
                        Golang, PHP, React, and Python for seamless integration.
                    </li>
                    <li>
                        Web Applications: Develop custom CMS platforms,
                        e-commerce solutions, and enterprise-level systems.
                    </li>
                    <li>
                        AI and Data Processing: Leverage Python for advanced
                        analytics, machine learning, and automation.
                    </li>
                </ul>
            </>
        )
    },
    {
        icon: (
            <svg
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M10 11C10 10.4477 10.4477 10 11 10H13C13.5523 10 14 10.4477 14 11C14 11.5523 13.5523 12 13 12H11C10.4477 12 10 11.5523 10 11Z" />
                <path d="M11 14C10.4477 14 10 14.4477 10 15C10 15.5523 10.4477 16 11 16H13C13.5523 16 14 15.5523 14 15C14 14.4477 13.5523 14 13 14H11Z" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.09447 4.74918C8.41606 4.03243 8 3.0648 8 2H10C10 3.10457 10.8954 4 12 4C13.1046 4 14 3.10457 14 2H16C16 3.0648 15.5839 4.03243 14.9055 4.74918C16.1782 5.45491 17.1673 6.6099 17.6586 8H19C19.5523 8 20 8.44772 20 9C20 9.55229 19.5523 10 19 10H18V12H19C19.5523 12 20 12.4477 20 13C20 13.5523 19.5523 14 19 14H18V16H19C19.5523 16 20 16.4477 20 17C20 17.5523 19.5523 18 19 18H17.6586C16.8349 20.3304 14.6124 22 12 22C9.38756 22 7.16508 20.3304 6.34141 18H5C4.44772 18 4 17.5523 4 17C4 16.4477 4.44772 16 5 16H6V14H5C4.44772 14 4 13.5523 4 13C4 12.4477 4.44772 12 5 12H6V10H5C4.44772 10 4 9.55229 4 9C4 8.44772 4.44772 8 5 8H6.34141C6.83274 6.6099 7.82181 5.45491 9.09447 4.74918ZM8 16V10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10V16C16 18.2091 14.2091 20 12 20C9.79086 20 8 18.2091 8 16Z"
                />
            </svg>
        ),
        slug: 'development',
        title: 'Development',
        text: 'Comprehensive Turnkey Project Development Services – delivering custom solutions tailored to your unique needs, guiding your project from initial concept to full-scale implementation.',
        content: (
            <>
                <h2>
                    Turnkey Project Development Services – Custom Solutions from
                    Start to Finish
                </h2>
                <p>
                    Welcome to our development services page! Our web studio
                    specializes in creating fully customized, end-to-end
                    solutions tailored to your business needs.
                </p>
                <h3>Comprehensive Approach</h3>
                <p>
                    From idea to implementation, we handle every stage of the
                    development process:
                </p>
                <ul className="list mb-2">
                    <li>
                        Consultation and Planning: Understanding your vision and
                        creating a roadmap.
                    </li>
                    <li>
                        Design: Crafting intuitive and visually appealing
                        interfaces.
                    </li>
                    <li>
                        Development: Building robust and scalable solutions.
                    </li>
                    <li>
                        Testing and Deployment: Ensuring quality and seamless
                        integration.
                    </li>
                </ul>

                <img
                    src={require('../imgs/projects/project1.webp')}
                    className="mb-2"
                    alt="Gersem"
                />
                <h3>Expertise in Leading Technologies</h3>
                <p>
                    Our team works with cutting-edge tools to deliver
                    exceptional results:
                </p>
                <ul className="list mb-2">
                    <li>
                        Frontend: Responsive designs with React and other modern
                        frameworks.
                    </li>
                    <li>
                        Backend: Reliable architecture using Golang, Python, or
                        PHP.
                    </li>
                    <li>
                        Mobile Development: iOS and Android apps for complete
                        digital coverage.
                    </li>
                    <li>
                        Cloud Solutions: Scalable and secure cloud integrations.
                    </li>
                </ul>

                <h3>Tailored to Your Business Needs</h3>
                <p>
                    We develop solutions that fit your unique requirements,
                    ensuring long-term value and scalability.
                </p>
                <h4>What We Offer</h4>
                <ul className="list mb-2">
                    <li>
                        Custom Web Applications: Bespoke platforms designed to
                        streamline your business processes.
                    </li>
                    <li>
                        E-commerce Solutions: From storefronts to payment
                        gateways, we cover all your online shopping needs.
                    </li>
                    <li>
                        Mobile Applications: High-performance apps for iOS and
                        Android.
                    </li>
                    <li>
                        Enterprise Software: Scalable systems for data
                        management, reporting, and internal processes.
                    </li>
                    <li>
                        API Development and Integration: Connect your tools and
                        platforms seamlessly.
                    </li>
                </ul>
            </>
        )
    }
    // {
    // 	icon: <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M18 10.5C19.6569 10.5 21 11.8431 21 13.5V19.5C21 21.1569 19.6569 22.5 18 22.5H6C4.34315 22.5 3 21.1569 3 19.5V13.5C3 11.8431 4.34315 10.5 6 10.5V7.5C6 4.18629 8.68629 1.5 12 1.5C15.3137 1.5 18 4.18629 18 7.5V10.5ZM12 3.5C14.2091 3.5 16 5.29086 16 7.5V10.5H8V7.5C8 5.29086 9.79086 3.5 12 3.5ZM18 12.5H6C5.44772 12.5 5 12.9477 5 13.5V19.5C5 20.0523 5.44772 20.5 6 20.5H18C18.5523 20.5 19 20.0523 19 19.5V13.5C19 12.9477 18.5523 12.5 18 12.5Z" /></svg>,
    // 	slug: 'it-security',
    // 	title: 'IT Security',
    // 	text: 'We offer intuitive and cutting-edge IT solutions to enhance your business. Our business services help streamline your operations and achieve greater efficiency.',
    // 	content: <>
    // 		<h2>Gersem Service</h2>
    // 		<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
    // 		<div className="grid g-2 mb-2">
    // 			<div>
    // 				<h3>Feature</h3>
    // 				<p>Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.</p>
    // 				<ul className="list">
    // 					<li>Lorem solor amet</li>
    // 					<li>Lorem solor amet</li>
    // 					<li>Lorem solor amet</li>
    // 					<li>Lorem solor amet</li>
    // 				</ul>
    // 			</div>
    // 			<img src={require('../imgs/projects/project1.webp')} alt="Gersem Service" />
    // 		</div>
    // 		<p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
    // 	</>
    // }
]
